/**
 * Wires Bootstrap action-confirmation modals from trigger data attributes.
 *
 * Trigger: data-bs-toggle="modal", data-bs-target, data-action-url, data-action-label
 * Modal:   .js-action-confirm-modal containing .js-action-confirm-form and
 *          .js-action-confirm-label
 */
export function initActionConfirmModals(root) {
  (root || document)
    .querySelectorAll(".js-action-confirm-modal")
    .forEach(function (modal) {
      if (modal.getAttribute("data-kt-initialized") === "1") {
        return;
      }
      modal.setAttribute("data-kt-initialized", "1");

      modal.addEventListener("show.bs.modal", function (event) {
        var trigger = event.relatedTarget;
        if (!trigger) {
          return;
        }

        var url = trigger.getAttribute("data-action-url") || "";
        var label = trigger.getAttribute("data-action-label") || "";
        var form = modal.querySelector(".js-action-confirm-form");
        var labelEl = modal.querySelector(".js-action-confirm-label");

        if (form) {
          form.action = url;
        }
        if (labelEl) {
          labelEl.textContent = label;
        }
      });
    });
}
